// Sélecteur de période du cockpit : année, cumul, trimestres et mois, en sélection multiple.

import { MONTHS_SHORT, QUARTERS, toggleMonths, ytdMonths } from '@cockpit/shared';
import { FilterChip, Select } from '@cockpit/ui';

/** Sur petit écran, les puces remplissent leur cellule de grille ; dès sm, elles reprennent leur largeur naturelle. */
const CHIP_FILL = 'w-full justify-center px-1 sm:w-auto sm:px-3';

export function PeriodPicker({
  years,
  year,
  finYear,
  months,
  lastClosed,
  onChange,
}: {
  years: number[];
  year: number;
  /** Année du reporting comptable : seule année dont les mois sont clôturés. */
  finYear: number;
  months: number[];
  lastClosed: number;
  onChange: (year: number, months: number[]) => void;
}) {
  const ytd = ytdMonths(lastClosed);
  const isYtd = months.length === ytd.length && months.every((m, i) => m === ytd[i]);
  const closed = (m: number) => year === finYear && m <= lastClosed;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2" role="group" aria-label="Période">
      <div className="grid grid-cols-4 items-center gap-1.5 sm:flex sm:flex-wrap sm:gap-2">
        <Select
          aria-label="Année"
          value={String(year)}
          onChange={(e) => onChange(Number(e.target.value), months)}
          className="col-span-2 h-8 w-full sm:w-auto"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </Select>
        <FilterChip className={CHIP_FILL + ' col-span-2'} active={isYtd} onClick={() => onChange(year, ytd)}>
          Cumul
        </FilterChip>
        {QUARTERS.map((q) => (
          <FilterChip
            key={q.key}
            className={CHIP_FILL}
            active={q.months.every((m) => months.includes(m))}
            onClick={() => onChange(year, toggleMonths(months, q.months))}
          >
            {q.key}
          </FilterChip>
        ))}
      </div>
      <div className="grid grid-cols-6 gap-1.5 sm:flex sm:flex-wrap sm:items-center sm:gap-2">
        {MONTHS_SHORT.map((label, i) => {
          const m = i + 1;
          return (
            <span
              key={m}
              className="block"
              title={closed(m) ? undefined : 'Mois non clôturé en comptabilité : CA seul'}
            >
              <FilterChip
                className={CHIP_FILL}
                active={months.includes(m)}
                onClick={() => onChange(year, toggleMonths(months, [m]))}
              >
                {label}
              </FilterChip>
            </span>
          );
        })}
      </div>
    </div>
  );
}
